<template>
  <div>
    <el-form ref="addForm" status-icon :model="addForm" label-width="120px" size="small" class="bg-#fff mx-20 pr-30 py-20" :rules="rules">
      <el-form-item label="所属项目：" prop="communityId">
        <el-select v-model="addForm.communityId" filterable clearable placeholder="选择所属项目" :disabled="disabledChange" @change="getCommunityName">
          <el-option v-for="item in searchCommunities" :key="item.communityId" :label="item.communityName" :value="item.communityId" />
        </el-select>
      </el-form-item>
      <el-form-item label="房屋编号：" prop="buildingRoomCode">
        <el-select
          v-model="addForm.buildingRoomCode"
          filterable
          remote
          clearable
          :remote-method="remoteMethod"
          value-key="buildingRoomId"
          :disabled="!addForm.communityId"
          placeholder="填写两位数以上的房屋编号"
        >
          <el-option
            v-for="item in indexThis.buildingRoomListArr"
            :key="item.buildingRoomId"
            :label="item.buildingRoomCode"
            :value="{ buildingRoomCode: item.buildingRoomCode, buildingRoomId: item.buildingRoomId }"
          />
        </el-select>
      </el-form-item>
      <template v-if="judgeObjISEmpty(indexThis.housesInfo)">
        <el-form-item label="住户类型：" prop="householdType">
          <el-radio v-model="addForm.householdType" :label="1">个人</el-radio>
          <el-radio v-model="addForm.householdType" :label="2">公司</el-radio>
        </el-form-item>
        <el-form-item label="住户角色：" prop="ownershipRelation">
          <el-radio-group v-model="addForm.ownershipRelation">
            <el-radio :label="1">业主</el-radio>
            <el-radio :label="2">住户</el-radio>
            <el-radio :label="3">家属</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <el-form-item v-else label="住户类型：" prop="householdType">
        {{ dictType('residentType', indexThis.housesInfo.householdType) }}
      </el-form-item>
      <el-form-item
        :label="addForm.householdType === 1 ? '住户姓名：' : '公司姓名：'"
        prop="householdName"
        :rules="{ required: true, message: addForm.householdType === 1 ? '住户姓名不能为空' : '公司姓名不能为空', trigger: 'change' }"
      >
        <el-input
          v-angle="addForm.householdName"
          v-model="addForm.householdName"
          :placeholder="addForm.householdType === 1 ? '填写住户姓名' : '填写公司姓名'"
          clearable
          :disabled="disabledChange"
        />
      </el-form-item>
      <el-form-item label="联系方式：" prop="householdPhone">
        <el-input v-model="addForm.householdPhone" placeholder="填写手机号/座机号，座机号示例：02227565399" clearable disabled />
      </el-form-item>
      <el-form-item label="工单分类：" prop="categoryId">
        <el-cascader
          ref="cascader"
          :key="keyValue"
          v-model="addForm.categoryId"
          :disabled="!addForm.communityId"
          placeholder="选择工单分类"
          :options="indexThis.worksheetCategoryListArr"
          :props="{ expandTrigger: 'click' }"
          @change="change"
        />
      </el-form-item>
      <el-form-item label="报修内容：" prop="content">
        <el-input v-angle="addForm.content" v-model="addForm.content" type="textarea" :rows="4" placeholder="填写报修内容" />
      </el-form-item>
      <el-form-item label="报修情况：" prop="urgentType">
        <el-radio-group v-model="addForm.urgentType">
          <el-radio :label="1">紧急</el-radio>
          <el-radio :label="2">重要</el-radio>
          <el-radio :label="3">一般</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="预约时间：" prop="appointmentTime">
        <el-date-picker v-model="addForm.appointmentTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择预约时间" />
      </el-form-item>
    </el-form>
    <FixedTwoButton :activeClass="sidebarIsOpen ? 'width210' : 'width54'">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </div>
</template>

<script>
import { worksheetSubmit } from '@/api/workOrder'
import formatRequestData from '@/utils/formatRequestData'
import { householdIndividualInfoIns, companyInfoIns, householdBindRoom, householdBaseInfoPage } from '@/api/propertyManage'

export default {
  inject: ['indexThis'],
  data() {
    return {
      addForm: {
        communityId: '',
        buildingRoomCode: '',
        buildingRoomId: '',
        householdName: '',
        categoryId: '',
        content: '',
        urgentType: 3,
        appointmentTime: '',
        categoryName: '',
        source: 3,
        ownershipRelation: 1,
        householdType: 1,
        householdPhone: '',
      },
      rules: {
        communityId: [{ required: true, message: '所属项目不能为空', trigger: 'change' }],
        householdType: [{ required: true, message: '住户类型不能为空', trigger: 'change' }],
        ownershipRelation: [{ required: true, message: '住户角色不能为空', trigger: 'change' }],
        buildingRoomCode: [{ required: true, message: '房屋编号不能为空', trigger: 'change' }],
        categoryId: [{ required: true, message: '工单分类不能为空', trigger: 'change' }],
        content: [{ required: true, message: '报修内容不能为空', trigger: 'change' }],
        urgentType: [{ required: true, message: '报修情况不能为空', trigger: 'change' }],
        householdPhone: [
          { required: true, message: '联系方式不能为空', trigger: 'change' },
          {
            required: true,
            pattern: /^(((0\d{2,3})?[0-9]{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/,
            message: '联系方式格式不正确',
            trigger: 'change',
          },
        ],
      },
      disabled: true,
      keyValue: 0,
    }
  },
  computed: {
    disabledChange() {
      return this.indexThis.housesList.length !== 0
    },
  },
  watch: {
    'addForm.communityId': {
      handler(val) {
        this.disabled = !val
        if (val) {
          this.indexThis.worksheetCategoryList({
            communityId: val,
            filterMissRule: true,
          })
        }
      },
      deep: true,
    },
    'indexThis.housesInfo': {
      handler() {
        // this.init()
      },
      deep: true,
    },
    'indexThis.worksheetCategoryListArr': {
      deep: true,
      handler() {
        this.keyValue++
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.addForm = { ...this.addForm, ...this.indexThis.housesInfo }
      this.addForm.householdType = this.indexThis.housesInfo.householdType ? this.indexThis.housesInfo.householdType : 1
      this.addForm.householdPhone = this.indexThis.userPhoneNumber
    },
    async submitForm() {
      const formatArr = formatRequestData(this.addForm)
      const valid = await this.$refs.addForm.validate().catch(() => {})
      if (!valid) return false
      formatArr.categoryId = formatArr.categoryId[1]
      const { data: res1 } = await worksheetSubmit(formatArr)
      if (!res1) return this.$message.error('新增失败')
      if (!this.indexThis.housesList.length) {
        let params =
          this.addForm.householdType === 1
            ? {
                communityId: formatArr.communityId,
                householdName: formatArr.householdName,
                householdPhone: this.indexThis.userPhoneNumber,
                householdType: formatArr.householdType,
              }
            : {
                communityId: formatArr.communityId,
                companyName: formatArr.householdName,
                companyContactPhone: this.indexThis.userPhoneNumber,
                householdType: formatArr.householdType,
              }
        const { data: res } = await (this.addForm.householdType === 1 ? householdIndividualInfoIns(params) : companyInfoIns(params))
        if (!res) return this.$message.error('新增失败')
        const { data } = await householdBaseInfoPage({ householdPhone: this.indexThis.userPhoneNumber })
        const { data: res1 } = await householdBindRoom({
          buildRoomCode: formatArr.buildingRoomCode,
          buildRoomId: formatArr.buildingRoomId,
          ownershipRelation: formatArr.ownershipRelation,
          householdId: data[0].id,
        })
        if (!res1) return this.$message.error('新增失败')
        await this.indexThis.householdList()
        this.$nextTick(() => this.$refs.addForm.clearValidate(['categoryId', 'content', 'urgentType']))
      }
      this.$message.success('新增成功')
      this.resetForm()
    },
    resetForm() {
      this.$refs.addForm.resetFields()
      this.init()
    },
    getCommunityName() {
      this.addForm.buildingRoomId = ''
      this.addForm.buildingRoomCode = ''
      this.indexThis.buildingRoomListArr = []
      this.indexThis.worksheetCategoryListArr = []
    },
    remoteMethod(e) {
      if (e.length < 2) return
      this.indexThis.buildingRoomList({
        queryValue: e,
        communityId: this.addForm.communityId,
      })
    },
    change() {
      this.addForm.categoryName = this.$refs.cascader.getCheckedNodes()[0].label
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload {
  display: inline-block !important;
  text-align: center;
  line-height: 64px;
}
::v-deep .el-upload-list__item {
  display: inline-block;
  width: 64px;
  height: 64px;
  .el-upload--picture-card i {
    font-size: 16px;
  }
}
</style>
